module.exports = __webpack_public_path__ + "img/Ja-T200.cb29901b.gif";